module.exports = __webpack_public_path__ + "img/sy.be17cc13.svg";